var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link_02"},[_c('div',{staticClass:"jugadores-plantilla avenirnextltpro-medium-big-stone-10px",on:{"click":function($event){return _vm.clickBreadCrumbs(2)}}},[_vm._v(" Jugadores - Plantilla ")])])}
var staticRenderFns = []

export { render, staticRenderFns }